<template>
  <YdDialog
    :title="title"
    :visible.sync="showVisible"
    append-to-body
    @close="closeEdit"
    width="60%"
    @open="openEdit"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      style="margin-left: 30px; margin-right: 10px"
      size="mini"
      label-position="left"
      label-width="100px"
    >
      <div class="title-box">基本信息</div>
      <el-form-item label="活动名称" prop="name">
        <el-input
          type="text"
          placeholder="不超过10个字"
          v-model="form.name"
          maxlength="10"
          show-word-limit
          style="width: 300px"
        />
      </el-form-item>
      <el-form-item label="隶属公司" prop="merchantId">
        <YdMerchantSelector
          v-model="form.merchantId"
          styles="width: 300px"
          placeholder="请选择隶属公司"
        />
      </el-form-item>
      <el-form-item label="活动时间" required>
        <el-date-picker
          v-model="form.startTime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="date"
          placeholder="开始日期"
          :picker-options="pickerOptions1"
          style="width: 200px"
          @change="activeChange($event, 'start')"
        />
        <span> - </span>
        <el-date-picker
          v-model="form.endTime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="date"
          placeholder="结束日期"
          :picker-options="pickerOptions1"
          style="width: 200px"
          @change="activeChange($event, 'end')"
        />
      </el-form-item>
      <el-form-item label="抢购时间">
        <el-row v-if="form.time && form.time.length">
          <div
            v-for="(item, index) in form.time"
            :key="index"
            class="margin-bottom-10 flex flex-align-center"
          >
            <!-- <el-time-select
              format="HH:mm"
              value-format="HH:mm"
              v-model="item.startTime"
              :picker-options="pickerOptions"
              @change="timeChange(index)"
              placeholder="请选择时"
            />
            <span class="margin-x-5"> - </span>
            <el-time-select
              format="HH:mm"
              value-format="HH:mm"
              v-model="item.endTime"
              :picker-options="pickerOptions"
              @change="timeChange(index)"
              placeholder="请选择分"
            /> -->
            <el-time-picker
              format="HH:mm"
              value-format="HH:mm"
              v-model="item.startTime"
              :picker-options="{
                selectableRange: testSelectableRange
              }"
              @change="timeChange(index)"
              placeholder="请选择时"
            />
            <span class="margin-x-5"> - </span>
            <el-time-picker
              format="HH:mm"
              value-format="HH:mm"
              v-model="item.endTime"
              :picker-options="{
                selectableRange: testSelectableRange
              }"
              @change="timeChange(index)"
              placeholder="请选择分"
            />
            <i
              class="el-icon-remove margin-left-10"
              v-if="index !== 0"
              style="font-size: 20px"
              @click="controlsTime('del', index)"
            ></i>
          </div>
        </el-row>
        <el-row>
          <i class="el-icon-circle-plus" style="font-size: 25px" @click="controlsTime('add')"></i>
        </el-row>
      </el-form-item>
      <div class="title-box">乘客端展示</div>
      <el-form-item label="活动头图" prop="headImgUrl" required>
        <el-upload
          ref="uploadRef"
          :action="doUpload"
          :headers="headers"
          name="file"
          list-type="picture-card"
          :before-upload="(file) => handleBeforeUpload(file, 750, 432)"
          :on-success="
            (response, file, fileList) => {
              return uploadSuccess(response, file, fileList)
            }
          "
          :on-error="handleUploadError"
          :on-remove="handleRemove"
          :file-list="fileList"
          :show-file-list="true"
          style="width: 100%"
          :data="{ code: 'activity' }"
          :class="{ disabled: uploadDisabled }"
        >
          <i class="el-icon-plus"></i>
          <div class="el-upload__tip" slot="tip">jpg/png格式，宽度750，高度432，不超过500kb。</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="活动背景色" prop="backcolor">
        <el-color-picker style="width: 100px" v-model="form.backcolor" />
      </el-form-item>
      <el-form-item label=" 活动规则" prop="rule">
        <rich-text-editor v-model="form.rule" />
      </el-form-item>
      <div style="display: flex; justify-content: space-between; align-items: center">
        <div class="title-box">活动奖励</div>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAddCoupon"
          size="mini"
          >添加优惠券</el-button
        >
      </div>
      <div style="padding-top: 10px">
        <el-table :data="couponItem" border size="mini" max-height="280px">
          <el-table-column label="序号" type="index" width="50" align="center" />
          <el-table-column label="优惠券名称" align="center" prop="name" />
          <el-table-column label="所属礼包" align="center" prop="giftName" />
          <el-table-column label="金额/个" align="center" prop="discountsMoney" width="80" />
          <el-table-column label="剩余数量" align="center" prop="surplusNum" width="100" />
          <el-table-column label="每次领取数量" align="center" prop="num">
            <template slot-scope="scope">
              <avue-input-number v-model="scope.row.num" min-rows="0" style="width: 8vw" />
            </template>
          </el-table-column>
          <el-table-column label="每日限量" align="center" prop="num">
            <template slot-scope="scope">
              <avue-input-number v-model="scope.row.dayNum" min-rows="0" style="width: 8vw" />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="deletes(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-form-item label="每人限领" prop="everyPersonTime" class="margin-top-10">
        <el-input-number
          size="mini"
          v-model="form.everyPersonTime"
          placeholder="请输入"
          :controls="false"
          style="width: 80px"
          :precision="0"
          :min="1"
        />
        次
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeEdit">取 消</el-button>
      <el-button type="primary" @click="save">保 存</el-button>
    </div>
    <select-coupon
      ref="selectCoupon"
      v-if="selectVisible"
      @getCouponItem="getCouponItem"
      :disable="true"
    />
  </YdDialog>
</template>

<script>
  import RichTextEditor from '@/components/RichTextEditor/RichTextEditor'
  import env from '@/config/env'
  import { getToken } from '@/util/auth'
  import SelectCoupon from '../../components/sendcoupon/select-coupon'
  import dayjs from 'dayjs'
  import { isEmpty } from 'lodash-es'

  export default {
    components: {
      SelectCoupon,
      RichTextEditor
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      advertisingInfo: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        showVisible: false,
        selectVisible: false,
        doUpload: env.uploadUrl + env.ferryUrl + '/oss/uploadV2',
        // doUpload: 'https://custom-pre.ayundi.cn' + env.ferryUrl + '/oss/uploadV2',
        headers: {
          Authorization: 'Bearer ' + getToken()
        },
        rules: {
          name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
          backcolor: [{ required: true, message: '请输入活动背景色', trigger: 'change' }],
          merchantId: [{ required: true, message: '请选择隶属公司', trigger: 'change' }],
          headImgUrl: [{ required: true, message: '请上传活动头图', trigger: 'blur' }],
          everyPersonTime: [{ required: true, message: '请输入正确次数', trigger: 'blur' }]
        },
        form: {
          name: '',
          merchantId: '',
          startTime: '',
          endTime: '',
          headImgUrl: '',
          backcolor: '',
          rule: '',
          couponRelationVos: [],
          everyPersonTime: 1,
          type: 4,
          time: [
            {
              startTime: '',
              endTime: ''
            }
          ]
        },
        uploadDisabled: false,
        couponItem: [],
        isEdit: false,
        title: '新建活动',
        pickerOptions: {
          start: '00:00',
          end: '24:00',
          step: '00:30'
        },
        selectTime: '',
        disabledHour: [1],
        pickerOptions1: {
          disabledDate: (time) => {
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
          }
          // selectableRange:
          //   new Date().getHours() + ':' + (new Date().getMinutes() + 1) + ':00' + ' - 23:59:59'
        },
        testSelectableRange: []
      }
    },
    watch: {
      // 开始时间
      'form.startTime'(selectTime) {
        // this.timeSelectChange(selectTime)
      },
      // 结束时间
      'form.endTime'(selectTime) {
        // this.timeSelectChange(selectTime)
      }
    },
    mounted() {
      this.showVisible = this.visible
      if (!isEmpty(this.advertisingInfo)) {
        this.title = '编辑'
        this.isEdit = true
        this.uploadDisabled = true
        this.fileList = [{ url: this.advertisingInfo.headImgUrl }]
        this.form = {
          ...this.advertisingInfo,
          type: 4,
          time: []
        }
        if (!isEmpty(this.advertisingInfo.couponInfoList)) {
          this.advertisingInfo.couponInfoList.forEach((item) => {
            item.name = item.couponName
          })
          this.couponItem = this.advertisingInfo.couponInfoList
        }
        if (!isEmpty(this.advertisingInfo.activityTimeList)) {
          this.advertisingInfo.activityTimeList.forEach((item) => {
            this.form.time.push({
              startTime: item.start.substr(0, 5),
              endTime: item.end.substr(0, 5)
            })
          })
          // 设置开始选择范围
          // this.pickerOptions.start = this.form.time[this.form.time.length - 1].startTime
          // 选择后禁用已选时间段
          if (this.advertisingInfo.activityTimeList.length === 1) {
            this.testSelectableRange = []
          } else {
            this.disabledTime()
          }
        } else {
          this.form.time.push({
            startTime: '',
            endTime: ''
          })
        }
      }
    },
    methods: {
      pickerOptionStart() {
        const s = dayjs().second()
        const m = dayjs().minute()
        const h = dayjs().hour()
        return {
          // 日期限制
          disabledDate: (time) => {
            return Date.now() - 3600 * 1000 * 24 > time.getTime()
          },
          // 时间限制
          selectableRange: h + ':' + m + ':' + s + '- 23:59:59'
        }
      },
      pickerOptionEnd() {
        if (!this.form.startTime) {
          return
        }
        const s = dayjs(this.form.startTime).second()
        const m = dayjs(this.form.startTime).minute()
        const h = dayjs(this.form.startTime).hour()
        return {
          // 日期限制
          disabledDate: (time) => {
            return time.getTime() < new Date(this.form.startTime).getTime() - 86400000
          },
          // 时间限制
          selectableRange: h + ':' + m + ':' + s + '- 23:59:59'
        }
      },
      handleAddCoupon() {
        this.selectVisible = true
        this.$nextTick(() => {
          this.$refs.selectCoupon.init()
        })
      },
      handleBeforeUpload(file, imgWidth, imgHeight) {
        return new Promise((resolve, reject) => {
          const uploadTypes = ['jpg', 'jpeg', 'png', 'gif']
          // 获取文件类型，确保正确变量名
          const filetype = file.name.replace(/.+\./, '').toLowerCase()

          // 检查文件类型
          if (!uploadTypes.includes(filetype)) {
            this.$message.warning({
              message: '请上传后缀名为jpg、jpeg、png、gif的附件'
            })
            reject(new Error('文件类型不符'))
            return
          }

          // 检查图片尺寸
          this.getImgSize(file).then((res) => {
            const { width, height } = res
            if (width !== imgWidth || height !== imgHeight) {
              this.$message.warning({
                message: '尺寸不符，请修改尺寸后重新上传！'
              })
              this.uploadDisabled = false
              reject(new Error('尺寸不符'))
              return
            }

            // 文件名修改逻辑
            const newFileName = `image-${Date.now()}.${filetype}`
            const newFile = new File([file], newFileName, { type: file.type })

            // 显示 loading 状态，禁用上传按钮
            this.$loading()
            this.uploadDisabled = true

            // 继续上传，传递修改后的文件对象
            resolve(newFile)
          })
        })
      },
      uploadSuccess(res, file, fileList, type) {
        this.$loading().close()
        if (JSON.stringify(res.data) === '{}') {
          this.$message.warning({
            message: '请修改文件名后重新上传'
          })
          const index = this.$refs.uploadRef.uploadFiles.findIndex((e) => e.uid === file.uid)
          this.$refs.uploadRef.uploadFiles.splice(index, 1)
          this.uploadDisabled = false
          return
        }
        this.form.headImgUrl = res.data.url
      },
      // 上传失败
      handleUploadError() {
        this.$loading().close()
        this.$modal.msgError('上传失败，请重试')
        this.uploadDisabled = false
      },
      handleRemove(file, fileList) {
        this.form.headImgUrl = ''
        this.uploadDisabled = false
      },
      save() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            if (!this.form.startTime || !this.form.endTime) {
              this.$message.warning('请先选择活动时间！')
              return
            }
            if (!this.form.headImgUrl) {
              this.$message.warning('请上传活动头图！')
              return
            }
            if (isEmpty(this.couponItem)) {
              this.$message.warning('请添加活动奖励！')
              return
            }
            if (!isEmpty(this.form.time)) {
              this.form.time = this.form.time.filter((item, index) => {
                return index === 0 || (item.startTime && item.endTime)
              })
            }
            if (!isEmpty(this.form.time)) {
              this.form.activityTimeList = []
              this.form.time.forEach((item) => {
                if (item.startTime && item.endTime) {
                  this.form.activityTimeList.push({
                    end: item.endTime + ':00',
                    start: item.startTime + ':00'
                  })
                }
              })
            }
            this.form.couponRelationVos = this.couponItem.map((item) => {
              return {
                couponId: item.id || item.couponId,
                type: item.type,
                num: item.num,
                dayNum: item.dayNum
              }
            })
            // if (this.isEdit) {
            //   delete this.form.personTime
            // }
            // delete this.form.time
            this.$emit('saveEdit', this.form)
          }
        })
      },
      closeEdit() {
        this.uploadDisabled = false
        this.form = {
          name: '',
          merchantId: '',
          startTime: '',
          endTime: '',
          headImgUrl: '',
          backcolor: '',
          rule: '',
          couponRelationVos: [],
          everyPersonTime: '',
          type: 4,
          time: [
            {
              startTime: '',
              endTime: ''
            }
          ]
        }
        this.showVisible = false
        this.isEdit = false
        this.couponItem = []
        this.$emit('closeEdit')
      },
      getImgSize(imgFile) {
        return new Promise((resolve) => {
          const reader = new FileReader()
          reader.readAsDataURL(imgFile)
          reader.onload = function () {
            const image = new Image()
            image.src = reader.result
            image.onload = function () {
              resolve({
                width: this.width,
                height: this.height,
                src: this.src
              })
            }
          }
        })
      },
      deletes(index) {
        this.couponItem.splice(index, 1)
      },
      getCouponItem(couponItem) {
        // this.couponItem.push(...couponItem)
        // this.couponItem = this.couponItem.filter((item, index, self) => {
        //   return self.findIndex((el) => el.id === item.id) === index
        // })
        couponItem.forEach((item) => {
          item.dayNum = 100
        })
        this.couponItem = [
          ...new Set([...this.couponItem, ...couponItem].map((item) => JSON.stringify(item)))
        ].map((item) => JSON.parse(item))
      },
      controlsTime(type, index) {
        if (this.form.time.length && type === 'add') {
          const lastList = JSON.parse(JSON.stringify(this.form.time))
          const newObj = lastList[lastList.length - 1]
          if (!newObj.startTime || !newObj.endTime) {
            this.$message({
              message: '请选择时间',
              type: 'warning'
            })
            return
          }
          // 设置开始选择范围
          // this.pickerOptions.start = newObj.endTime
          // 选择后禁用已选时间段
          this.disabledTime()
        }

        if (type === 'add') {
          this.form.time.push({ startTime: '', endTime: '' })
        } else {
          this.form.time.splice(index, 1)
          // 设置开始选择范围
          // this.pickerOptions.start =
          //   this.form.time.length === 1
          //     ? '00:00'
          //     : this.form.time[this.form.time.length - 1].startTime
          if (this.form.time.length > 1) {
            this.disabledTime()
          } else {
            this.testSelectableRange = []
          }
        }
      },
      timeChange(index) {
        const row = this.form.time[index]
        console.log('row', row, index)

        // 检查当前行的开始时间和结束时间
        if (row.startTime && row.endTime) {
          // 结束时间不能小于开始时间
          if (!this.changeCompareDate(row.startTime, row.endTime)) {
            this.$message({
              message: '开始时间必须小于结束时间',
              type: 'warning'
            })
            row.endTime = ''
            return false
          }
        }

        // 如果有多个时间段，检查相邻的时间
        if (this.form.time.length > 1) {
          if (index > 0) {
            // 检查上一个时间段的结束时间和当前时间段的开始时间
            const prevRow = this.form.time[index - 1]
            if (prevRow.endTime && row.startTime) {
              if (!this.changeCompareDate(prevRow.endTime, row.startTime)) {
                this.$message({
                  message: '当前时间段的开始时间必须大于上一个时间段的结束时间',
                  type: 'warning'
                })
                row.startTime = ''
                return false
              }
            }
          }
        }
        // 开始时间时间不能超过总的活动开始时间
        const activeStartTime = this.form.endTime
        if (row.startTime && activeStartTime) {
          if (!this.isStartTimeInActivity(this.form.startTime, this.form.endTime, row.startTime)) {
            this.$message({
              message: '开始时间不能超过整个活动的开始结束时间',
              type: 'warning'
            })
            row.startTime = ''
            return false
          }
        }

        // 结束时间不能超过总的活动结束时间
        const activeEndTime = this.form.endTime
        if (row.endTime && activeEndTime) {
          if (!this.isStartTimeInActivity(this.form.startTime, this.form.endTime, row.endTime)) {
            this.$message({
              message: '结束时间不能超过整个活动的开始结束时间',
              type: 'warning'
            })
            row.endTime = ''
            return false
          }
        }
      },

      changeCompareDate(t1, t2) {
        const date = new Date()
        const a = t1.split(':')
        const b = t2.split(':')
        return date.setHours(a[0], a[1]) < date.setHours(b[0], b[1])
      },
      splitTimeRanges(selectedRanges) {
        const dayStart = '00:00:00'
        const dayEnd = '23:59:59' // 使用24:00:00作为一天结束的标记

        // 先对时间段按开始时间排序
        selectedRanges.sort((a, b) => a.startTime.localeCompare(b.startTime))

        const result = []

        // 检查从00:00:00到第一个时间段开始的部分
        if (selectedRanges[0].startTime !== dayStart) {
          const [hour, minute] = selectedRanges[0].startTime.split(':').map(Number)
          if (hour + minute > 0) {
            result.push(
              `${dayStart} - ${this.adjustTime(selectedRanges[0].startTime, 'subtract', true)}`
            )
          }
        }

        // 遍历所有时间段，找出它们之间的空白时间段
        for (let i = 0; i < selectedRanges.length - 1; i++) {
          const currentEnd = selectedRanges[i].endTime
          const nextStart = selectedRanges[i + 1].startTime

          if (currentEnd !== nextStart) {
            result.push(
              `${this.adjustTime(currentEnd, 'add', false)} - ${this.adjustTime(
                nextStart,
                'subtract',
                true
              )}`
            )
          }
        }

        // 检查最后一个时间段结束到24:00:00的部分
        const lastEnd = selectedRanges[selectedRanges.length - 1].endTime
        const [hour, minute] = lastEnd.split(':').map(Number)
        // hour+minute<82为边界值判断，当选择23:59时不切割时间，直接禁用
        if (lastEnd !== dayEnd && hour + minute < 82) {
          result.push(`${this.adjustTime(lastEnd, 'add', false)} - ${dayEnd}`)
        }

        return result
      },
      // 调整时间：'subtract' 减去1分钟，'add' 加上1分钟
      // 参数isEndTime用于决定是否格式化为59秒还是00秒
      adjustTime(time, action, isEndTime) {
        const [hour, minute] = time.split(':').map(Number)
        let newMinute = minute
        let newHour = hour
        if (action === 'add') {
          newMinute += 1
          if (newMinute >= 60) {
            newMinute = 0
            newHour += 1
          }
        } else if (action === 'subtract') {
          newMinute -= 1
          if (newMinute < 0) {
            newMinute = 59
            newHour -= 1
          }
        }

        // 格式化为HH:MM:00 或 HH:MM:59
        const formattedHour = newHour.toString().padStart(2, '0')
        const formattedMinute = newMinute.toString().padStart(2, '0')

        return `${formattedHour}:${formattedMinute}:${isEndTime ? '59' : '00'}`
      },
      isStartTimeInActivity(activityStartTime, activityEndTime, checkTime) {
        // 将活动时间转换为Date对象
        const activityStart = new Date(activityStartTime)
        const activityEnd = new Date(activityEndTime)

        // 将开始时间（时:分:秒）附加到活动日期上，生成新的 Date 对象
        const [activityStartDate] = activityStartTime.split(' ') // 获取活动的日期部分
        const checkStart = new Date(`${activityStartDate} ${checkTime}`)
        // 判断开始时间是否在活动时间内
        return checkStart >= activityStart && checkStart < activityEnd
      },
      timeSelectChange(selectTime) {
        // 限制可选日期
        const date = new Date(new Date(selectTime).setHours(0, 0, 0, 0)).getTime()
        const today = new Date(new Date().setHours(0, 0, 0, 0)).getTime()
        if (date <= today) {
          // 当选择的日期就是当天的时候，这个时候就要限制时间应当大于此时此刻的时分秒
          this.pickerOptions1.selectableRange =
            new Date().getHours() + ':' + (new Date().getMinutes() + 1) + ':00' + '- 23:59:59'
        } else {
          // 当选择的日期大于当天的时候，这时需要把时分秒的限制放开，否则不能选择
          this.pickerOptions1.selectableRange = '00:00:00 - 23:59:59'
        }
      },
      activeChange(time, type) {
        const value = time.split(' ')[0]
        type === 'start'
          ? (this.form.startTime = value + ' 00:00:00')
          : (this.form.endTime = value + ' 23:59:59')
      },
      disabledTime() {
        // 计算已选时间段
        const timeArr = []
        this.form.time.forEach((item) => {
          if (item.startTime && item.endTime) {
            timeArr.push(item)
          }
        })
        if (timeArr.length) {
          this.testSelectableRange = this.splitTimeRanges(timeArr)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title-box {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }

  .tipsBox {
    display: inline-block;
    font-size: 13px;
    color: #9f9f9f;
    margin-left: 10px;
  }

  .disabled ::v-deep .el-upload--picture-card {
    display: none;
  }

  .disabled ::v-deep .el-upload__tip {
    margin-top: -10px;
  }
  ::v-deep .el-color-picker__trigger {
    width: 50px !important;
    height: 30px !important;
  }
</style>
